











import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({ name: "ui-table-body-item" })
export default class UiTableBodyItemComponent extends Vue {
  @Prop({ type: Number, default: 0 })         col: number;
  @Prop({ type: Number, default: 0 })         row: number;
  @Prop({ type: Boolean, default: false })   sele: boolean;
  @Prop({default: false}) borderLeft: boolean;
  @Prop({default: false}) borderRight: boolean;
  @Prop({default: false}) borderY: boolean;

  
  selectInner = this.sele;
  ClickRow() {
    this.$emit("changeCol", this.row, this.col);
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-table/src/ui-table-body-item.vue